import Swal from 'sweetalert2';
import { escapeHtml } from '../../../shared/escape-html.utils';

export function confirmDeleteDialog(
  title: string,
  id: string,
  onConfirm: () => void,
) {
  Swal.fire({
    title: '¿Seguro?',
    text: 'Se eliminarán todos los criterios asociados',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Sí, eliminar',
    cancelButtonText: 'Cancelar',
  }).then(result => {
    if (result.isConfirmed) onConfirm();
  });
}

export function confirmRemoveSubquestionsDialog(
  count: number,
  onConfirm: () => void,
  onCancel?: () => void,
) {
  Swal.fire({
    title: '¿Quitar subpreguntas?',
    text: `Se eliminarán las ${count} subpreguntas asociadas. Esta acción no se puede deshacer.`,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#d33',
    cancelButtonColor: '#3085d6',
    confirmButtonText: 'Sí, eliminar',
    cancelButtonText: 'Cancelar',
  }).then(result => {
    if (result.isConfirmed) onConfirm();
    else if (onCancel) onCancel();
  });
}

export function showHistoryDialog(
  title: string,
  onForceDelete: () => void,
  onToggleDisable: () => void,
) {
  Swal.fire({
    icon: 'warning',
    title: 'Tiene historial',
    html: `"<strong>${escapeHtml(title)}</strong>" tiene respuestas asociadas.<br><br>
      <div class="alert alert-warning mb-0"><i class="fas fa-exclamation-triangle"></i> Si la elimina se perderán todas las respuestas y archivos.</div>`,
    showCancelButton: true,
    confirmButtonText: 'Eliminar definitivamente',
    confirmButtonColor: '#dc3545',
    cancelButtonText: 'Solo deshabilitar',
    cancelButtonColor: '#ffc107',
    showDenyButton: true,
    denyButtonText: 'Cancelar',
    denyButtonColor: '#6c757d',
  }).then(result => {
    if (result.isConfirmed) onForceDelete();
    else if (result.dismiss === Swal.DismissReason.cancel) onToggleDisable();
  });
}
